/**
 * After add-to-cart bottom sheet.
 * Cart drawer stays closed until the shopper taps the cart icon.
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-atc-nudge]');
  if (!root) return;

  var configEl = document.querySelector('[data-nudge-config]');
  var config = {};
  try {
    config = configEl ? JSON.parse(configEl.textContent) : {};
  } catch (e) {
    config = {};
  }

  var shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var titleEl = root.querySelector('[data-nudge-title]');
  var bodyEl = root.querySelector('[data-nudge-body]');
  var primaryBtn = root.querySelector('[data-nudge-primary]');
  var companionBtn = root.querySelector('[data-nudge-companion]');
  var secondaryBtn = root.querySelector('[data-nudge-secondary]');
  var current = null;
  var lastFocus = null;

  function cartHasProductId(cart, productId) {
    if (!cart || !cart.items || !productId) return false;
    var id = Number(productId);
    if (!id) return false;
    return cart.items.some(function (item) {
      return Number(item.product_id) === id || Number(item.variant_id) === id || Number(item.id) === id;
    });
  }

  function countKindInCart(cart, kind) {
    if (!cart || !cart.items) return 0;
    return cart.items.reduce(function (sum, line) {
      if (classify(line) === kind) return sum + Number(line.quantity || 0);
      return sum;
    }, 0);
  }

  function normalizeAdd(payload) {
    if (!payload) return [];
    if (Array.isArray(payload.items)) return payload.items;
    if (payload.id && (payload.handle || payload.product_title || payload.variant_id)) {
      return [payload];
    }
    return [];
  }

  function classify(item) {
    var handle = String(item.handle || '').toLowerCase();
    var title = String(item.product_title || item.title || '').toLowerCase();
    var hay = handle + ' ' + title;

    if (hay.indexOf('starter') !== -1) return 'none';
    /* Disposable (use-and-throw) panties: no 'add more pairs' or detergent sheet */
    if (hay.indexOf('disposable') !== -1 || hay.indexOf('use-throw') !== -1 || hay.indexOf('use and throw') !== -1 || hay.indexOf('use & throw') !== -1) return 'none';
    if (handle.indexOf('pantyliner') !== -1 || handle.indexOf('panty-liner') !== -1 || title.indexOf('panty liner') !== -1 || title.indexOf('pantyliner') !== -1) {
      return 'none';
    }
    if (handle.indexOf('detergent') !== -1 || handle.indexOf('intimate-wash') !== -1 || handle.indexOf('steriliz') !== -1) {
      return 'none';
    }

    if (handle.indexOf('menstrual-cup') !== -1 || (handle.indexOf('cup') !== -1 && handle.indexOf('steriliz') === -1 && title.indexOf('cup') !== -1)) {
      return 'companion-cup';
    }

    if (handle.indexOf('cloth-pad') !== -1 || title.indexOf('cloth pad') !== -1) {
      return 'companion-cloth';
    }

    if (
      handle.indexOf('mens') !== -1
      || handle.indexOf('men-s') !== -1
      || handle.indexOf('trunk') !== -1
      || title.indexOf("men's") !== -1
    ) {
      return 'qty-mens';
    }

    if (
      handle.indexOf('period-pant') !== -1
      || handle.indexOf('reusable-period') !== -1
      || handle.indexOf('high-waist') !== -1
      || handle.indexOf('shorties') !== -1
      || handle.indexOf('eco-high-waist') !== -1
      || handle.indexOf('underwear') !== -1
    ) {
      return 'qty-underwear';
    }

    return 'none';
  }

  function countKindInItems(items, kind) {
    if (!items || !items.length) return 0;
    return items.reduce(function (sum, item) {
      if (classify(item) === kind) return sum + Number(item.quantity || 1);
      return sum;
    }, 0);
  }

  function needsDetergent(kind, cart) {
    if (kind !== 'qty-underwear' && kind !== 'qty-mens' && kind !== 'companion-cloth') return false;
    var detergent = config.detergent || {};
    if (!detergent.available || !detergent.variantId) return false;
    if (cartHasProductId(cart, detergent.id)) return false;
    return !cartHasProductId(cart, detergent.variantId);
  }

  function needsSterilizer(kind, cart) {
    if (kind !== 'companion-cup') return false;
    var sterilizer = config.sterilizer || {};
    if (!sterilizer.available || !sterilizer.variantId) return false;
    return !cartHasProductId(cart, sterilizer.id);
  }

  function buildRule(item, cart, addedItems) {
    var kind = classify(item);
    if (kind === 'none') return null;

    if (kind === 'companion-cloth') {
      if (!needsDetergent(kind, cart)) return null;
      return {
        kind: kind,
        item: item,
        title: 'Add liquid detergent for this.',
        body: 'Regular detergents can reduce absorbency over time.',
        primary: 'Add detergent for this',
        primaryAction: 'add-detergent',
        secondary: 'Continue to cart',
        companion: '',
        companionAction: ''
      };
    }

    if (kind === 'companion-cup') {
      if (!needsSterilizer(kind, cart)) return null;
      return {
        kind: kind,
        item: item,
        title: 'Pair it with the sterilizer for 2 to 3 minute cleaning.',
        body: '',
        primary: 'Add sterilizer',
        primaryAction: 'add-sterilizer',
        secondary: 'Continue to cart',
        companion: '',
        companionAction: ''
      };
    }

    /* Women's period panties only: 1 pair this add AND 1 pair in cart. */
    if (kind === 'qty-underwear') {
      var addedUnderwear = countKindInItems(addedItems && addedItems.length ? addedItems : [item], 'qty-underwear');
      var underwearInCart = countKindInCart(cart, 'qty-underwear');
      if (addedUnderwear !== 1 || underwearInCart !== 1) return null;

      var underwearRule = {
        kind: kind,
        item: item,
        title: 'Most women use 3 to 4 pairs to get through a cycle',
        body: '',
        primary: 'Add more',
        primaryAction: 'add-more',
        secondary: 'Continue to cart',
        companion: '',
        companionAction: ''
      };

      if (needsDetergent(kind, cart)) {
        underwearRule.companion = 'Add detergent for this';
        underwearRule.companionAction = 'add-detergent';
        underwearRule.body = 'Regular detergents can reduce absorbency over time.';
      }

      return underwearRule;
    }

    if (kind === 'qty-mens') {
      var addedMens = countKindInItems(addedItems && addedItems.length ? addedItems : [item], 'qty-mens');
      var mensInCart = countKindInCart(cart, 'qty-mens');
      if (addedMens !== 1 || mensInCart !== 1) return null;

      var mensRule = {
        kind: kind,
        item: item,
        title: 'Most men use 2 to 3 pairs to get through a week comfortably',
        body: '',
        primary: 'Add more',
        primaryAction: 'add-more',
        secondary: 'Continue to cart',
        companion: '',
        companionAction: ''
      };
      if (needsDetergent(kind, cart)) {
        mensRule.companion = 'Add detergent for this';
        mensRule.companionAction = 'add-detergent';
        mensRule.body = 'Regular detergents can reduce absorbency over time.';
      }
      return mensRule;
    }

    return null;
  }

  function pickItem(items) {
    var scored = items.map(function (item) {
      var kind = classify(item);
      var rank = 0;
      if (kind.indexOf('qty') === 0) rank = 3;
      else if (kind.indexOf('companion') === 0) rank = 2;
      return { item: item, kind: kind, rank: rank };
    }).sort(function (a, b) {
      return b.rank - a.rank;
    });
    return scored.length ? scored[0].item : items[0];
  }

  function resetButtons() {
    if (primaryBtn) primaryBtn.disabled = false;
    if (companionBtn) companionBtn.disabled = false;
    if (secondaryBtn) secondaryBtn.disabled = false;
  }

  function close() {
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    current = null;
    resetButtons();
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function open(rule) {
    current = rule;
    resetButtons();
    titleEl.textContent = rule.title;
    bodyEl.textContent = rule.body || '';
    primaryBtn.textContent = rule.primary;
    secondaryBtn.textContent = rule.secondary || 'Continue to cart';
    secondaryBtn.style.color = '#C4673A';
    secondaryBtn.style.webkitTextFillColor = '#C4673A';
    if (rule.companion) {
      companionBtn.hidden = false;
      companionBtn.textContent = rule.companion;
    } else {
      companionBtn.hidden = true;
      companionBtn.textContent = '';
    }
    lastFocus = document.activeElement;
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    primaryBtn.focus();
  }

  function withCart(run) {
    if (window.FabpadCart && window.FabpadCart.fetchCart) {
      return window.FabpadCart.fetchCart().then(run);
    }
    return fetch(shopRoot + 'cart.js').then(function (res) { return res.json(); }).then(run);
  }

  function addVariant(variantId, extras) {
    var payload = Object.assign({ id: Number(variantId), quantity: 1 }, extras || {});
    return fetch(shopRoot + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (res) {
      if (!res.ok) throw new Error('Add failed');
      return res.json();
    }).then(function () {
      if (window.FabpadCart && window.FabpadCart.refresh) {
        return window.FabpadCart.refresh();
      }
    });
  }

  function changeLine(key, fields) {
    var payload = Object.assign({ id: key }, fields);
    return fetch(shopRoot + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (res) {
      if (!res.ok) throw new Error('Change failed');
      return res.json();
    }).then(function () {
      if (window.FabpadCart && window.FabpadCart.refresh) {
        return window.FabpadCart.refresh();
      }
    });
  }

  function goCart() {
    close();
    if (window.FabpadCart && typeof window.FabpadCart.open === 'function') {
      window.FabpadCart.open();
    }
  }

  function setBusy(btn, busy) {
    if (!btn) return;
    btn.disabled = !!busy;
  }

  function handlePrimary() {
    if (!current) return;
    var action = current.primaryAction;
    var item = current.item;
    setBusy(primaryBtn, true);

    if (action === 'add-more') {
      addVariant(item.variant_id || item.id)
        .then(function () { close(); })
        .catch(function () { setBusy(primaryBtn, false); });
      return;
    }

    if (action === 'add-sterilizer') {
      addVariant(config.sterilizer.variantId)
        .then(function () { close(); })
        .catch(function () { setBusy(primaryBtn, false); });
      return;
    }

    if (action === 'add-detergent') {
      addVariant(config.detergent.variantId)
        .then(function () { close(); })
        .catch(function () { setBusy(primaryBtn, false); });
      return;
    }

    setBusy(primaryBtn, false);
  }

  function handleCompanion() {
    if (!current || current.companionAction !== 'add-detergent') return;
    setBusy(companionBtn, true);
    addVariant(config.detergent.variantId)
      .then(function () { close(); })
      .catch(function () { setBusy(companionBtn, false); });
  }

  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-nudge-close]')) {
      close();
      return;
    }
    if (e.target.closest('[data-nudge-primary]')) {
      handlePrimary();
      return;
    }
    if (e.target.closest('[data-nudge-companion]')) {
      handleCompanion();
      return;
    }
    if (e.target.closest('[data-nudge-secondary]')) {
      goCart();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.classList.contains('is-open')) close();
  });

  window.FabpadNudge = {
    show: function (payload, cart) {
      var items = normalizeAdd(payload);
      if (!items.length) return Promise.resolve();

      function present(liveCart) {
        var item = pickItem(items);
        var rule = buildRule(item, liveCart, items);
        if (!rule) return;
        open(rule);
      }

      if (cart && cart.items) {
        present(cart);
        return Promise.resolve();
      }
      return withCart(present);
    },
    close: close
  };
})();
